var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.amount > 0)?_c('span',{staticClass:"subscribers-count",attrs:{"title":_vm.title}},[_c('UsersIcon',{staticClass:"rating-amount__icon"}),_c('span',{staticClass:"rating-amount__text"},[_vm._v(_vm._s(_vm.amount))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }